// extracted by mini-css-extract-plugin
export default {"container":"UserInfo_container__aYaOC","wrapperForm":"UserInfo_wrapperForm__cu5Ig","header":"UserInfo_header__klQvJ"};